function convertCubicInchToCubicFoot(num) {
  let eq =
    "Converting " +
    num +
    " cubic inch to cubic foot: \n" +
    num +
    " * 0.0005787037037  = ";
  let rep = num * 0.0005787037037 ;
  return eq + rep.toFixed(6);
}

function convertCubicInchToLiter(num) {
  let eq =
    "Converting " +
    num +
    " cubic inch to liter: \n" +
    num +
    " * 0.016387064 = ";
  let rep = num * 0.016387064;
  return eq + rep.toFixed(4);
}

function convertCubicInchToCubicYard(num) {
  let eq =
    "Converting " +
    num +
    " cubic inch to cubic yard: \n" +
    num +
    " * 0.00002143347051 = ";
  let rep = num * 0.00002143347051;
  return eq + rep.toFixed(7);
}

function convertCubicInchToCubicMile(num) {
  let eq =
    "Converting " +
    num +
    " cubic inch to cubic mile: \n" +
    num +
    " * 3.931465729e-15 = ";
  let rep = num * 3.931465729e-15;
  return eq + rep.toFixed(15);
}

function convertCubicInchToCubicMeter(num) {
  let eq =
    "Converting " +
    num +
    " cubic inch to cubic meter: \n" +
    num +
    " * 0.000016387064 = ";
  let rep = num * 0.000016387064;
  return eq + rep.toFixed(7);
}

export {
  convertCubicInchToCubicFoot,
  convertCubicInchToCubicMeter,
  convertCubicInchToCubicMile,
  convertCubicInchToCubicYard,
  convertCubicInchToLiter
};
